<template>
    <div class="fail-message">
        <p class="error" v-if="associateFailedString">
            {{
                $t('order_complete.associate_fail', {
                    devices: associateFailedString
                })
            }}
        </p>
        <p class="error" v-if="unassociateFailedString">
            {{
                $t('order_complete.unassociate_fail',{
                    devices: unassociateFailedString
                })
            }}
        </p>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
    props: {
        associateFailedString: String,
        unassociateFailedString: String
    },
    data() {

        return {

        };

    }
});
</script>

<style lang="less" scoped>
    .fail-message{
        .error{
            color: @error;
        }
    }
</style>
